import MortgagesValidations from '@/validations/mortgages.json';

export default ({ store }) => { store.commit('products/setValidations', MortgagesValidations.mortgages); };
